"use client";
import {
  CategoryStyleTypes,
  ICategory,
  IProduct_Category_Config_Customize,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import { Link } from "@/app/components/lib/navigation/Link";
import NextImage from "../../lib/NextImage";
import { useRef } from "react";
import { useGetCategoryAdvanceStyle } from "./helpers/useGetCategoryAdvanceStyle";
import { truncateString } from "@/utils/functions/functions";
import useIsClient from "@/hooks/useIsClient";

interface Props extends ICategory {
  categoryType: CategoryStyleTypes;
  customize: IProduct_Category_Config_Customize;
  showCategoryImage: boolean;
}
const Category: React.FC<Props> = ({
  id,
  categoryType,
  icon,
  name,
  customize,
  showCategoryImage,
  slug,
}) => {
  const catType = categoryType ?? CategoryStyleTypes.circle_icon;
  let cn = "";
  switch (catType) {
    case CategoryStyleTypes.square:
      cn = "category-square";
      break;
    case CategoryStyleTypes.square_primary:
      cn = "category-square primary";
      break;
    case CategoryStyleTypes.square_primary_title:
      cn = "category-square-colored-title";
      break;
    case CategoryStyleTypes.circle_img:
      cn = "category-circle-img";
      break;
    default:
      cn = "category-circle-img";
  }

  const lebleRef = useRef<HTMLDivElement>(null);
  const { advance_mode } = customize ?? {};
  const { advanceFontSize, advanceStyle, advancefullSize } =
    useGetCategoryAdvanceStyle(customize, lebleRef);
  const viewIcon = showCategoryImage && icon && icon !== "";
  const noImageClasses = " w-100 align-items-center";
  const isClient = useIsClient();
  const advanceMode = advance_mode && isClient;
  return (
    <Link prefetch={false} href={`/categories/${slug || id}`}>
      <div
        className={`${cn} ${viewIcon ? "" : "justify-content-center"} `}
        style={advanceMode ? { ...advanceStyle } : {}}
      >
        {viewIcon && (
          <div
            className="category-image-cover"
            style={advanceMode ? { ...advancefullSize } : {}}
          >
            <div
              className="category-image-container"
              style={advanceMode ? { width: "100%", height: "100%" } : {}}
            >
              <NextImage
                src={icon}
                alt="category"
                sizes="70px"
                objectFit="contain"
                style={{ backgroundColor: "#FFF" }}
              />
            </div>
          </div>
        )}
        <div
          ref={lebleRef}
          className={`category-label${advanceMode ? "-advance" : ""} ${
            !showCategoryImage ? noImageClasses : ""
          }`}
          style={advanceMode ? { fontSize: advanceFontSize } : {}}
        >
          {truncateString(name)}
        </div>
      </div>
    </Link>
  );
};

export default Category;
